module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tanum-008805de45f9585f4053a3e24907c82f.png";